import { ProgramSite } from '@tempus/trials-types';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const programSitesApi = {
  getProgramSite: async (institutionId: string, trialId: string): Promise<Pick<ProgramSite, 'status'>> => {
    return axios
      .get(`${TRIALS_API_ROOT}/programSites/institution/${institutionId}/trial/${trialId}/external`)
      .then(({ data }) => data);
  },
};
